import type { ExtensionSession } from '@extJurAutofill/externalPackagesContract/ExtensionSession';
import { MessageType } from '@extJurAutofill/shared/MessageType';

export interface InitializeExtensionMessage {
  type: MessageType.INITIALIZE_EXTENSION;
  payload: ExtensionSession;
}

const MESSAGE_TYPE = MessageType.INITIALIZE_EXTENSION;

export const dispatchInitializeExtensionMessage = (
  payload: ExtensionSession,
) => {
  window.postMessage({ payload, type: MESSAGE_TYPE }, window.location.origin);
};

export const listenForInitializeExtensionMessage = (
  handler: (message: InitializeExtensionMessage) => void,
): (() => void) => {
  const listener = (event: MessageEvent) => {
    if (event.source !== window || event.origin !== location.origin) return;
    if (event.data?.type !== MESSAGE_TYPE) return;
    handler(event.data as InitializeExtensionMessage);
  };

  window.addEventListener('message', listener);
  return () => window.removeEventListener('message', listener);
};
